import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import { collapsedSider } from 'recoil/atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { listMenuSider, pOpenKeys, pRoute } from 'utils/common/menu';
import { Link, useLocation } from 'react-router-dom';
import logo from 'assets/images/logo.png';
import logo_icon from 'assets/images/logo.png';
import { twMerge } from 'tailwind-merge';

const { Sider } = Layout;
const SiderLayout = () => {
  const [collapsed, setCollapsed] = useRecoilState(collapsedSider);
  const location = useLocation();
  return (
    <Sider
      collapsible
      theme="light"
      collapsed={collapsed}
      collapsedWidth={60}
      onCollapse={(value) => setCollapsed(value)}
      style={{
        backgroundColor: '#ffffff'
      }}
    >
      <div className="h-12 flex items-center justify-center">
        <img
          src={collapsed ? logo_icon : logo}
          alt=""
          className={twMerge('h-full object-contain py-1', collapsed && 'p-2')}
        />
      </div>
      <Menu
        theme="light"
        mode="inline"
        defaultSelectedKeys={[pRoute[location.pathname]]}
        defaultOpenKeys={[pOpenKeys[location.pathname]]}
        items={listMenuSider?.map((item) => ({
          ...item,
          label: !item?.children ? (
            <Link to={item?.key} className="font-medium">
              {item?.label}
            </Link>
          ) : (
            <p className="font-medium">{item?.label}</p>
          ),
          children:
            item?.children &&
            item?.children?.map((child) => ({
              ...child,
              label: (
                <Link to={child?.key} className="font-medium">
                  {child?.label}
                </Link>
              )
            }))
        }))}
      />
    </Sider>
  );
};

export default SiderLayout;
